import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-url-shortener',
    templateUrl: './url-shortener.component.html',
    styleUrls: ['./url-shortener.component.scss'],
    standalone: false
})
export class UrlShortenerComponent implements OnInit {

  public title = 'Generate short URL';
  public url = '';
  public shortUrl = '';

  constructor(private http: HttpClient) {
  }

  ngOnInit() {
  }

  submit() {
    if (this.url.length > 5) {
      this.http.get('https://s.ipeak.info/new/' + encodeURIComponent(this.url) + '/dXQNUehu39BNdwNtaLkhwQKP6Q8tYQzY').toPromise().then(result => {
        this.shortUrl = result['short_link'];
      });
    }
  }

  copyInputMessage() {
    const inputElement = document.getElementById('shorturl') as HTMLInputElement;
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
  }

}
